export default __webpack_public_path__ + "static/media/034-turkey.ad5b1f2d.svg";